<template>
    <div class="Activo">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-pencil</v-icon>
                                Lista de Activos fijo
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="activoEstado"
                                    label="Activo"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadActivo()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>
                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="menufiltro"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-activo
                                        v-if="menufiltro"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-activo>
                                </v-menu>

                                <!--<v-menu
                                    v-model="exportMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    left
                                    max-width="350"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-icon medium v-on="{ ...tooltip, ...menu }">fa fa-save</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Exportar Activos</span>
                                        </v-tooltip>
                                    </template>
                                    <v-card>
                                        <v-card-text pb-0>
                                            <v-text-field v-model="filename" label="Nombre del documento">
                                            </v-text-field>
                                            <v-text-field v-model="sheetname" label="Nombre de la hoja"> </v-text-field>

                                            <v-flex sm12 class="pb-3">
                                                <v-label>Columnas a exportar</v-label>
                                            </v-flex>
                                            <v-container fluid grid-list-xl py-0>
                                                <v-layout align-center wrap>
                                                    <v-flex
                                                        xs12
                                                        sm6
                                                        class="pa-0"
                                                        v-for="column in excelColumns"
                                                        :key="column.field"
                                                    >
                                                        <v-checkbox
                                                            v-model="column.status"
                                                            class="pt-0 mt-0"
                                                            :label="column.label"
                                                            :key="column.field"
                                                        >
                                                        </v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="red" flat @click="exportMenu = false">
                                                Cancelar
                                            </v-btn>
                                            <vue-excel-xlsx
                                                :data="ACTIVOS"
                                                :columns="computedExcelColumns"
                                                :filename="filename"
                                                :sheetname="sheetname"
                                            >
                                                <v-btn @click="exportMenu = false" color="success" flat>
                                                    Exportar
                                                </v-btn>
                                            </vue-excel-xlsx>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>-->

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Activo</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="ACTIVOS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.codigo }}</td>

                                        <td>{{ props.item.grupo_id ? props.item.grupo.nombre : "-" }}</td>
                                        <td>{{ props.item.tipo_id ? props.item.tipo.nombre : "-" }}</td>
                                        <td>{{ props.item.categoria_id ? props.item.categoria.nombre : "-" }}</td>

                                        <td>{{ props.item.descripcion }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :disabled="loading || menuLocked"
                                                            @click="openDetails(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver detalles</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Activo</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Activo</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            :disabled="loading || menuLocked"
                                                            @click="loadHistory(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen activos registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <activo-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </activo-form>
        <activo-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails"> </activo-details>
        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Activo'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const ActivoForm = () =>
    import(/* webpackChunkName: "activo-form" */ "@/components/finanzas/activo/activo-form/activo-form")
const ActivoDetails = () =>
    import(/* webpackChunkName: "activo-details" */ "@/components/finanzas/activo/activo-form/activo-details")
const CustomFilterActivo = () =>
    import(/* webpackChunkName: "activo-filter" */ "@/components/widgets/custom-filter-activo/custom-filter-activo")
const TimeLine = () =>
    import(/* webpackChunkName: "historial-time-line" */ "@/components/widgets/records-time-line/time-line")

export default {
    components: { ActivoDetails, ActivoForm, CustomFilterActivo, TimeLine },
    props: {
        //estado de los activos a cargar del back
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Código", value: "codigo" },
            { text: "Grupo", value: "grupo_id" },
            { text: "Tipo", value: "tipo_id" },
            { text: "Categoría", value: "categoria_id" },
            { text: "Descripción", value: "descripcion" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteActivoConfirmId: "",

        menuLocked: false,

        showDetails: false,
        detailsItem: null,

        //menu exportar
        exportMenu: false,
        excelColumns: Util.ActivoExcelColumns(),
        filename: "activos",
        sheetname: "seleccion",

        //filtro personalizado
        menufiltro: false,
        customFilter: null,
        activeFilters: 0,
        camposFilter: Util.EstudianteCampos(),

        activoEstado: "2",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_ACTIVOS", {
                    filter: this.filter.search,
                    activoEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar activo"
                this.editItem = item
            } else {
                this.title = "Nuevo activo"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteActivoConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteActivoConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_ACTIVO", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteActivoConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        loadActivo() {
            this.loadData(this.activoEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        searchData: _.debounce(function() {
            this.loadData(this.activoEstado, this.customfilter)
        }, 1000),

        openDetails(item) {
            if (!this.ACTIVOS.filter(el => el.id === item.id)[0].departamento) {
                //condicion para saber si los datos de este activo ya se cargo para no volver a pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_ACTIVO_DETAILS", item).then(error => {
                    if (error === null) {
                        this.detailsItem = item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            } else {
                this.detailsItem = item
                this.showDetails = true
            }
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Activo")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteActivoConfirmId = ""
            props.expanded = !props.expanded
        },

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.menufiltro = false
                this.activoEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.activoEstado, this.customfilter)
            } else {
                this.activoEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.activoEstado, this.customfilter)
                this.menufiltro = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["ACTIVOS"]),

        pagination: {
            get: function() {
                return this.$store.getters.ACTIVOS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_ACTIVOS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        },

        computedExcelColumns() {
            return this.excelColumns.filter(el => el.status)
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.activoEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.activoEstado, this.customfilter)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>
